import { render, staticRenderFns } from "./ProductAddedToListFromExtension.vue?vue&type=template&id=16d84826"
import script from "./ProductAddedToListFromExtension.vue?vue&type=script&lang=js"
export * from "./ProductAddedToListFromExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports